import React, { Component } from 'react';
import ModalVideo from 'react-modal-video'

class VideoCta extends Component {

    constructor() {
        super()
        this.state = {
            isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }

    openModal() {
        this.setState({ isOpen: true })
    }
    render() {
        return (
            <div>
                {/*====================  video cta area ====================*/}
                <div className="video-cta-area section-space--inner--120">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <div className="video-cta-content" data-aos="fade-right">
                                    <h4 className="video-cta-content__small-title">ABOUT US</h4>
                                    <h3 className="video-cta-content__title">Building Ghana's Infrastructure with Excellence</h3>
                                    <p className="video-cta-content__text">With decades of experience in construction, electrical engineering, and road works, Prixin delivers world-class infrastructure solutions. Our commitment to quality, safety, and innovation makes us the preferred partner for complex projects across Ghana.</p>
                                    <a href={`${process.env.PUBLIC_URL}/contact-us`} className="ht-btn ht-btn--round">CONTACT US</a>
                                </div>
                            </div>
                            <div className="col-lg-5 offset-lg-1 col-md-6">
                                <div className="cta-video-image" data-aos="fade-left">
                                    <div className="video-popup">
                                        <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='OrS-93U4AYQ' onClose={() => this.setState({ isOpen: false })} />
                                        <button onClick={this.openModal}>
                                            <div className="cta-video-image__image">
                                                <img src="assets/img/others/video-placeholder-2.jpg" className="img-fluid" alt="" />
                                            </div>
                                            <div className="cta-video-image__icon">
                                                <i className="ion-ios-play" />
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*====================  End of video cta area  ====================*/}
            </div>
        )
    }
}


export default VideoCta;